import { render, staticRenderFns } from "./signingArea.vue?vue&type=template&id=2e606f66&scoped=true&"
import script from "./signingArea.vue?vue&type=script&lang=js&"
export * from "./signingArea.vue?vue&type=script&lang=js&"
import style0 from "./signingArea.vue?vue&type=style&index=0&id=2e606f66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e606f66",
  null
  
)

export default component.exports